import React from 'react';
import { Hero } from '../components/Hero';
import { Stats } from '../components/Stats';
import { Services } from '../components/Services';
import { Events } from '../components/Events';
import { PilotInfo } from '../components/PilotInfo';
import { Contact } from '../components/Contact';
export function HomePage() {
  return <>
      <Hero data-id="element-569" data-mp="3kqmn5h94mv4f" />
      <Stats data-id="element-570" data-mp="3kquy33lovqcz" />
      <Services data-id="element-571" data-mp="3ko8uff1x5v01" />
      <Events data-id="element-572" data-mp="2x094uigcgan1" />
      <PilotInfo data-id="element-573" data-mp="2wzz9sggfzdah" />
      <Contact data-id="element-574" data-mp="2x1k4q76o4y8v" />
    </>;
}